<template>
    <div class="goods-info-item use-coupon">
        <p class="title">优惠券</p>
        <div class="coupon-info" @click="handleSelectCoupon(couponList.length)">
            <template v-if="couponInfo && Object.keys(couponInfo).length">
                <div v-if="couponInfo.id && couponInfo.id > -1">
                    <p class="text" 
                    v-if="couponInfo.type == 0"
                    >
                        <span class="text-bg">
                            {{couponInfo.isCouponThreshold === 1? `无门槛，减${couponInfo.value}`:`满 ¥${couponInfo.fullMinus}，减${couponInfo.value}`}} 
                        </span>
                        <span>{{`减¥${couponInfo.favorablePrice}`}}</span>
                    </p>
                    <p class="text" v-else>
                        <span class="text-bg">
                            {{couponInfo.isCouponThreshold === 1? `无门槛，${couponInfo.discount}折`:`满 ¥${couponInfo.fullMinus}，${couponInfo.discount}折`}} 
                        </span>
                        <span>{{`减¥${couponInfo.favorablePrice}`}}</span>
                    </p>
                </div>
                <p v-if="couponInfo.id == -1" class="text gray">不使用</p>
            </template>
            <template v-else>
                <p class="text">
                    <span v-if="couponList.length">共{{couponList.length}}张可用</span>
                    <span class="gray" v-else>暂无可用优惠券</span>
                </p>
            </template> 
            <i class="icon icon-right"></i>
        </div>
        <van-action-sheet v-model="isShow" title="优惠详情" :style="{'paddingBottom':bottomSafeHeight,'backgroundColor':'#FFFFFF'}">
            <div class="content">
                <van-radio-group v-model="couponUserId">
                    <van-cell-group>
                        <van-cell class="item"
                            clickable
                            v-for="item in couponList" 
                            :key="item.couponUserId" 
                            @click="couponUserId = item.couponUserId">
                            <template #title>
                                <div class="action-coupon-info">
                                    <span class="tag">优惠券</span>
                                    <p class="text" v-if="item.type == 0">{{item.isCouponThreshold === 1? `无门槛，减${item.value}`:`满 ¥${item.fullMinus}，减${item.value}`}}</p>
                                    <p class="text" v-else>{{item.isCouponThreshold === 1? `无门槛,${item.discount}折`:`满 ¥${item.fullMinus}，打${item.discount}折`}}</p>
                                </div>
                            </template>
                            <template #right-icon>
                                <van-radio :name="item.couponUserId" />
                            </template>
                        </van-cell>
                        <van-cell class="item"
                            @click="couponUserId = -1">
                            <template #title>
                                <div class="action-coupon-info">
                                    <p class="text">不使用</p>
                                </div>
                            </template>
                            <template #right-icon>
                                <van-radio :name="-1" />
                            </template>
                        </van-cell>
                    </van-cell-group>
                </van-radio-group>
            </div>
            <div class="close-box">
                <div class="close-btn" @click="onConfirm">确定</div>
            </div>
        </van-action-sheet>
    </div>
</template>

<script>
export default {
    name: 'couponList',
    props: {
        couponList: {
            type: Array,
            default: ()=>[]
        },
        couponInfo: {
            type: Object,
            default: ()=>{
                return {
                    id: '',
                }
            }
        },
        bottomSafeHeight: {
            type: [String, Number],
            default: '',
        },
        checkedCouponUserId: {
            type: [String,Number],
            default: '',
        },
    },
    watch: {
        checkedCouponUserId(newValue, oldValue) {
            if(newValue) {
                this.couponUserId = Number(newValue)
            }
        }
    },
    data() {
        return {
            isShow: false,
            couponUserId: this.checkedCouponUserId,
        }
    },
    methods: {
        handleSelectCoupon(value) {
            if(!value) {
                return false;
            }
            this.isShow = true;
            this.couponUserId = Number(this.checkedCouponUserId);
        },
        onConfirm() {
            if(!this.isClose) {
                this.isShow = false
                this.$emit('change', this.couponUserId);
            }
        },
    },
    
}
</script>

<style lang="less" scoped>
    .px2rem(@name,@px){
        @{name}: @px / 37.5px * 1rem
    }
    ::v-deep {
        .van-action-sheet__header {
            position: relative;
            font-weight: normal;
            .px2rem(font-size, 32);

        }
        .van-icon-cross {
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            color: #999;

        }
        .van-action-sheet__gap {
            display: none;
        }
        .van-action-sheet__content {
            .px2rem(margin-bottom, 9);
            position: relative;
            .px2rem(padding-bottom, 107);

        }
        .van-action-sheet__cancel {
            .px2rem(width, 686);
            .px2rem(height, 80);
            .px2rem(line-height, 80);
            .px2rem(font-size, 30);
            .px2rem(border-radius, 44);
            background-color: #1F94FF;
            margin: 0 auto;
            color: #fff;
            box-sizing: border-box;
            padding: 0;
            .px2rem(margin-bottom, 20);
        }
        .van-radio__icon {
            .px2rem(width, 28);
            .px2rem(height, 28);
            .van-icon {
                width: 100%;
                height: 100%;
                .px2rem(font-size, 28);
                &:before {
                    width: 100%;
                    height: 100%;
                }
                position: relative;
            }
            &.van-radio__icon--checked .van-icon-success:before {
                content: '';
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%,-50%);
                background: url('https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/goods/radio.png') no-repeat center center /100% 100%;
            }
        }
        .van-cell-group {
            &::after {
                display: none;
            }
        }
    }
    .icon-right {
        display: inline-block;
        width: 24px;
        height: 24px;
        background: url('https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/goods/icon_arrow_right.png') no-repeat center center /100% 100%;
    }
    .use-coupon {
        display: flex;
        font-size: 28px;
        padding:16px 0;
        .title {
            margin-right: 10px;
            color: #999;
        }
        .coupon-info {
            flex: 1;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            .text {
                display: flex;
                align-items: center;
                color: #FE5746;
                font-size: 28px;
                .text-bg {
                    display: flex;
                    align-items: center;
                    height: 36px;
                    font-size: 20px;
                    color: #793E38;
                    background-color: #F9D6D3;
                    padding: 0 16px 0 93px;
                    background-repeat: no-repeat;
                    background-position: left center;
                    background-size: 93px 100%;
                    background-image: url(https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/goods/text_bg.png);
                    margin-right: 16px;
                    border-radius: 4px;
                    overflow: hidden;
                }
            }
            .gray {
                color: #333333;
            }
        }
    }
    .content {
        max-height: 592px;
        overflow: auto;
        ::v-deep {
            .van-cell {
                padding: 0;
            }
            .van-cell,.van-cell__title {
                .px2rem(height, 98);
                .px2rem(font-size, 30);
                display: flex;
                align-items: center;
                color: #333;
            }
            .van-cell::after{
                display: none;
            }
        }
        padding: 0 32px;
        .item {
            .tag {
                background-color: rgba(255, 99, 82, .2);
                font-size: 22px;
                min-width: 88px;
                padding: 0 5px;
                box-sizing: border-box;
                text-align: center;
                line-height: 36px;
                color: #FF6352;
                margin-right: 12px;
                border-radius: 8px;
                display: inline-block;
                font-weight: normal;
            }
            .text {
                font-size: 30px;
                color: #333;
                font-weight: normal;
            }
            .action-coupon-info {
                display: flex;
                align-items: center;
            }
        }
    }
    .close-box {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 9px 32px;
        margin-bottom: 9px;
        border-top: 1px solid #EAEAEA;
    }
    .close-btn {
        height: 80px;
        line-height: 80px;
        background-color: #1F94FF;
        border-radius: 44px;
        font-size: 30px;
        color: #fff;
        text-align: center;
    }
</style>